module.exports = __webpack_public_path__ + "img/seamless_check_in.16714482.png";